module.exports = __webpack_public_path__ + "img/addPet.026d2713.svg";